// extracted by mini-css-extract-plugin
export default {"levelsList":"LevelsList_levelsList__LkvyY"};